// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__CdVnO"};